<h4>
  <i class="fa fa-icon-chemistry fs20 vl-m mr"></i> Pharmacy, Lab or Radiology
  <a class="fs14 ml-lg" *ngIf="!intakeReport" (click)="addMedicalCenter()" tooltip="Add Pharmacy, Lab or Radiology"><i class="fa fa-plus fs12"></i> Add</a>
</h4>
<app-medical-center *ngIf="showAddMedicalCenterForm" [medicalCenter]="medicalCenter" (addMedicalCenterEmitter)="closeMedicalCenterForm($event)"> </app-medical-center>
<app-medical-centers #medicalCentersComponent [patient_id]="patient_id" (editMedicalCenterEmitter)="editMedicalCenter($event)" [intakeReport]="intakeReport"></app-medical-centers>
